import { Injectable, signal } from '@angular/core';

export enum ToggleAction {
  ADDED,
  REMOVED,
}

@Injectable({
  providedIn: 'root',
})
export class TimingTowerService {
  public activeList = signal<string[]>([]);

  public toggleActive(teamNumber: string): ToggleAction {
    if (!this.activeList().includes(teamNumber)) {
      this.setActive(teamNumber);
      return ToggleAction.ADDED;
    } else {
      this.setInactive(teamNumber);
      return ToggleAction.REMOVED;
    }
  }

  public setActive(teamNumber: string) {
    this.activeList.update((al) => [...al, teamNumber]);
  }

  public setInactive(teamNumber: string) {
    this.activeList.update((al) => al.filter((tn) => tn !== teamNumber));
  }
}
